import React from 'react';
import FooterFooter from "../../components/footerfooter";
import { StyledHeader } from "../../Styles";
import AlphaherdAllocationSection from './containers/alphaherd/alphaherd.allocationSection';
import AlphaherdCounterSection from './containers/alphaherd/alphaherd.counterSection';
import AlphaherdHeroSection from './containers/alphaherd/alphaherd.heroSection';
import AlphaherdIslandDropsSection from './containers/alphaherd/alphaherd.islandDropsSection';
import AlphaherdIslandSection from './containers/alphaherd/alphaherd.islandSection';
import AlphaherdProceedFromSection from './containers/alphaherd/alphaherd.proceedFromSection';
import "./styles/alphaherd.scss";
//SWITCH VARIABLE FOR PAGE STYLE
const theme = "GREY"; //LIGHT, GREY, RETRO
const Alphaherd = () => {
  return (
    <div className="greyscheme">
      <StyledHeader theme={theme} />
      <div className="greyscheme">
        <AlphaherdHeroSection/>
        <AlphaherdCounterSection/>
        <AlphaherdIslandSection/>
        <AlphaherdIslandDropsSection/>
        <AlphaherdProceedFromSection/>
        <AlphaherdAllocationSection/>
      </div>
      <FooterFooter />
    </div>
  )
}

export default Alphaherd;